import React, { useState } from 'react'
import EventAgent from '@hotmart/event-agent-js'
import { useTranslation } from 'react-i18next'
import Link from '../Link'
import styles from './styles.module.css'

const IsPageUseful = ({ url }) => {
  const [isUseful, setIsUseful] = useState(false)
  const [formStep, setFormStep] = useState(1)
  const [motive, setMotive] = useState('')
  const [mail, setMail] = useState(typeof window !== `undefined` ? localStorage.getItem('mail') : '')
  const { t } = useTranslation()

  const handleOpinionClick = answer => {
    setIsUseful(answer)
    setFormStep(2)
  }

  const submitForm = e => {
    e.preventDefault()
    const evtData = { url, is_useful: isUseful, motive, mail }
    EventAgent.send({
      system: 'developers',
      entity: 'page',
      action: 'useful',
      event: evtData,
    })
    localStorage.setItem('mail', mail)
    setFormStep(4)
  }

  const submitMotiveForm = e => {
    e.preventDefault()
    setFormStep(3)
  }

  const renderButtons = () => (
    <>
      <p>{t('isPageUseful.question')}</p>
      <div className={styles.buttons}>
        <button
          className="hot-button hot-button--primary"
          onClick={() => handleOpinionClick(true)}
        >
          {t('general.yes')}
        </button>
        <button
          className="hot-button hot-button--primary"
          onClick={() => handleOpinionClick(false)}
        >
          {t('general.no')}
        </button>
      </div>
    </>
  )

  const renderMail = () => (
    <form onSubmit={submitForm}>
      <div className={`hot-form-group ${styles.formGroup}`}>
        <label htmlFor="mail">
          {t('isPageUseful.mail')}
          <input
            type="email"
            className="hot-form__input"
            data-testid="isuseful-mail"
            id="mail"
            onChange={e => setMail(e.target.value)}
            value={mail || ''}
          />
        </label>
        <div className={styles.formInputButton}>
          <div className={styles.mailInputButton}>
            <button className="hot-button hot-button--primary">
              {t('general.send')}
            </button>
          </div>
        </div>
      </div>
    </form>
  )

  const renderMotive = () => (
    <form onSubmit={submitMotiveForm}>
      <div className={`hot-form-group ${styles.formGroup}`}>
        <label htmlFor="motive">
          {isUseful
            ? t('isPageUseful.positiveQuestion')
            : t('isPageUseful.negativeQuestion')}
          <textarea
            type="textarea"
            className="hot-form__input"
            data-testid="isuseful-motive"
            id="motive"
            maxLength={240}
            onChange={e => setMotive(e.target.value)}
            placeholder={t('isPageUseful.questionPlaceholder')}
            rows={2}
            value={motive}
          />
        </label>
        <div className={styles.formInputButton}>
          <div>
            <button className="hot-button hot-button--primary">
              {t('general.send')}
            </button>
          </div>
        </div>
      </div>
    </form>
  )

  const renderThanks = () => (
    <div data-testid="isuseful-thanks">
      <span>{t('isPageUseful.thanksMessage')}, </span>
      <Link href={t('navLinks.support.link')}>
        {t('isPageUseful.thanksMessageSupportLink')}
      </Link>
      .
    </div>
  )

  const renderStep = () => {
    switch(formStep) {
      case(2): return renderMotive()
      case(3): return renderMail()
      case(4): return renderThanks()
      default:
        return renderButtons()
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className="hot-row">
          <div className="hot-col-lg-6">
            {renderStep()}
          </div>
        </div>
      </div>
    </div>
  )
}

export default IsPageUseful
